<template>
          <v-card  style="margin-top: 2rem">
            <v-card-title class="subheading font-weight-bold">{{ item ? item.customName : "Brak" }}</v-card-title>
            <v-divider></v-divider>
            <v-container>
              <v-flex xs12 lg8 offset-xs2>
                <v-img v-if="item && item.thumbImg" :src="'data:image/png;base64,'+ (item && item.thumbImg ? item.thumbImg : '')" aspect-ratio="1" class="cursorPointner"
                       contain max-height="256"
                       max-width="256"
                       @click="$emit('goToDocument',item)"></v-img>
              </v-flex>

                <v-text-field style="margin-top: 2rem" :value="item.customName" label="Nazwa:" readonly></v-text-field>
                <v-text-field style="margin-top: 2rem" :value="item.archType" label="Typ archiwum:"  readonly></v-text-field>

                <v-text-field  style="margin-top: 2rem" :value="item.creationTime" label="Data stworzenia: "  readonly></v-text-field>
                <v-text-field style="margin-top: 2rem" :value="item.modifyTime" label="Data edycji: "  readonly></v-text-field>


              <div v-if="!viewOnly" lg2 sm12>
                <slot name="actions" v-bind:item="item">
                  <v-btn style="margin-left: 0;float:left" :disabled="!['2','3','4'].includes(item.document.status)" color="green" @click="$emit('goToDocument',item)">{{ getDocumentText(item) }}</v-btn>
                  <EditArchive   :archive="item" :archiveOrgin="archiveOrgin" />
                </slot>
              </div>
            </v-container>
          </v-card>
</template>

<script>
import EditArchive from "@/components/archive/dialogs/EditArchive"
export default {
  name: "Waiting",
  components:{
    EditArchive
  },
  props: ['item','viewOnly', 'archiveOrgin'],
  data:()=>({
    documents : [],
    fields :[],
    file:null,
    schemaAssigned :{},
    loading : true,
    rowsPerPageItems: [4, 8, 12],
    pagination: {
      rowsPerPage: 4
    },
  }),
  created() {

  },
  methods:{
    getUser(id){
      let user = this.$store.getters.user(id)
      if(!user)
        return ""
      return user.name + " " + user.surname
    },
    getIcon(state){
      switch (parseInt(state)){
      case 1:
        return "waiting"
      case 2:
        return "task_plus"
      default:
        return "error"
      }
    },
    getStatus(state){
      switch (parseInt(state)){
      case 1:
        return "Trwa procesowanie dokumentu"
      case 2:
        return "Oczekuje"
      case 400:
        return "Bład"
      default:
        return "Inny"
      }
    },
    getDocumentText(archive){
      switch (parseInt(archive.document.status)){
      case 2:
        return "Poczekalnia"
      case 3:
      case 4:
      default:
        return "Dokument"
      }
    },
  },
}
</script>

<style scoped>
.cursorPointner{
  cursor: pointer;
}
</style>